<template>
  <nav>
    <div class="nav-wrapper grey lighten-2">
      <ul class="left">
        <li v-show="$auth.hasRoles('admin', 'recs-admin')">
          <a class="dropdown-trigger btn btn-small grey lighten-1 blue-grey-text text-darken-4"
             data-target="ticker-admin-rec-dropdown"
          >
            Quick Links
            <i class="material-icons right">arrow_drop_down</i>
          </a>
          <ul id="ticker-admin-rec-dropdown" class="dropdown-content">
            <li class="grey lighten-4">
              <router-link to="/tickeradmin/addrecommendation" class="blue-grey-text text-darken-3">
                Add Rec
              </router-link>
            </li>
            <li class="divider" tabindex="-1" />
            <li class="grey lighten-4">
              <router-link to="/tickeradmin/addportfolio" class="blue-grey-text text-darken-3">
                Add Portfolio
              </router-link>
            </li>
            <li class="divider" tabindex="-1" />
            <li class="grey lighten-4">
              <router-link to="/tickeradmin/addservice" class="blue-grey-text text-darken-3">
                Add Service
              </router-link>
            </li>
            <li class="divider" tabindex="-1" />
            <li class="grey lighten-4">
              <router-link to="/tickeradmin/editrecquick" class="blue-grey-text text-darken-3">
                Edit Rec
              </router-link>
            </li>
          </ul>
        </li>
        <li>
          <router-link to="/tickeradmin/listcompanies" class="btn-small amber blue-grey-text"
                       :class="$route.name === 'ticker-admin-list-companies' ? 'btn text-darken-4' : 'btn-flat lighten-4 text-darken-1'"
          >
            Companies
          </router-link>
        </li>
        <li>
          <router-link to="/tickeradmin/listservices" class="btn-small amber blue-grey-text"
                       :class="$route.name === 'ticker-admin-list-services' ? 'btn text-darken-4' : 'btn-flat lighten-4 text-darken-1'"
          >
            Services
          </router-link>
        </li>
        <li>
          <router-link to="/tickeradmin/listoptions" class="btn-small amber blue-grey-text"
                       :class="$route.name === 'ticker-admin-list-options' ? 'btn text-darken-4' : 'btn-flat lighten-4 text-darken-1'"
          >
            Options
          </router-link>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'TickerAdminNav',
  props: {},
  methods: {
    initDropdown() {
      this.materialize.Dropdown.init(document.querySelectorAll('.dropdown-trigger'), {
        alignment: 'left',
        autoTrigger: true,
        container: null,
        coverTrigger: false,
        closeOnClick: true,
        hover: false,
      });
    },
  },
  mounted() {
    this.initDropdown();
  },
};
</script>

<style lang="scss" scoped>
@import '@/main.scss';

</style>
